import React, { Fragment, useState } from "react";
import { Tabs, TabPanel } from "react-tabs"; // TabList,  Tab
import { Button, Form, FormGroup, Label } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { yupCategoryValidation } from "../../utils/authValidation";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import "../../assets/styles/admin.css";
// import { validateImage } from "../../utils/multiuseFunctions";

const AddBrandForm = ({ payload }) => {
  //{payload}
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    defaultValues: payload || {},
    resolver: yupResolver(yupCategoryValidation()),
  });

  const [editData, setEditData] = useState();

  const onSubmitHandler = async (data) => {
    const formData = new FormData();
    setSingleClick(true);
    Object.keys(data).map((el) => formData.append(el, data[el]));
    try {
      const { _id } = payload || {};
      if (Object.keys(errors).length === 0) {
        if (_id) {
          const response = await adminInstance().put(
            `/api/admin/updateBrand/${_id}`,
            formData
          );
          const { code, msg } = response.data;
          setEditData({ ...editData, isUpdate: true });
          if (code === 200) {
            toast.success(msg, { toastId: 1 });
            reset();
            history.push("/brand-list");
          } else {
            toast.error(msg, { toastId: 1 });
          }
        } else {
          // console.log('i am in add condition')
          const response = await adminInstance().post(
            "/api/admin/createBrand",
            formData
          );
          const { code, msg } = response.data;
          if (code === 200) {
            reset();
            toast.success(msg, { toastId: 1 });
            history.push("/brand-list");
          } else {
            toast.error(msg, { toastId: 1 });
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const [singleClick, setSingleClick] = useState(false);

  // create a preview as a side effect, whenever selected file is changed

  // const onSelectFile = async (e) => {
  //   try {
  //     if (!e.target.files || e.target.files.length === 0) {
  //       setSelectedFile(undefined);

  //       // Update the "No file chosen..." element text to "No file chosen..."
  //       const noFileText = document.getElementById("noFile");
  //       noFileText.textContent = "No file chosen...";

  //       return;
  //     }

  //     await validateImage(e.target.files[0]);
  //     setSelectedFile(e.target.files[0]);

  //     // Update the "No file chosen..." element text with the selected file name
  //     const noFileText = document.getElementById("noFile");
  //     noFileText.textContent = e.target.files[0].name;
  //   } catch (error) {
  //     const { msg, valid } = error || {};
  //     if (!valid) {
  //       toast.error(msg);
  //     }
  //   }
  // };

  return (
    <Fragment>
      <Tabs>
        <TabPanel>
          <Form
            className="needs-validation user-add"
            onSubmit={handleSubmit(onSubmitHandler)}>
            {/* <h4>Add Category</h4> */}
            <FormGroup className="row justify-content-start mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Name
                </Label>
                <input
                  {...register("name")}
                  className="form-control"
                  type="text"
                  defaultValue={payload.name || ""}
                />
                <p className="text-danger">{errors.name?.message}</p>
              </div>
            </FormGroup>
            {/* <FormGroup className="row justify-content-start mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span></span> Description{" "}
                </Label>
                <textarea rows="4" cols="12"
                  {...register('description')}
                  className='form-control'
                  type='text'
                  defaultValue={payload.description || ''}
                />
              </div>
            </FormGroup> */}
            <div className="form-button d-flex justify-content-start pt-3">
              <Button color="primary" type="submit" disabled={singleClick}>
                Submit
              </Button>
            </div>
          </Form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};
export default AddBrandForm;
